module.exports = __webpack_public_path__ + "static/media/Espacio-eidefut.0a7e6ed1.JPG";